/* global axios */
import ApiClient from './ApiClient';

// Triggers an AI outbound call (FlexCalls) for a conversation — the
// "Call with AI" button. Separate from api/agents/flexcalls.js, which is the
// canvas node config client for the agent builder.
class FlexcallsCallAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create(conversationId) {
    return axios.post(`${this.url}/${conversationId}/flexcalls_call`);
  }
}

export default new FlexcallsCallAPI();
